import { render, staticRenderFns } from "./MangaPanel.vue?vue&type=template&id=33053a63&"
import script from "./MangaPanel.vue?vue&type=script&lang=js&"
export * from "./MangaPanel.vue?vue&type=script&lang=js&"
import style0 from "./MangaPanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports